import * as ambassadorWixDynamicPageRouterV1Page from './dynamic-page-router-v1-page-pages.http.js';
import * as ambassadorWixDynamicPageRouterV1PageTypes from './dynamic-page-router-v1-page-pages.types.js';
import * as ambassadorWixDynamicPageRouterV1PageUniversalTypes from './dynamic-page-router-v1-page-pages.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getRouterSitemapCount(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetRouterSitemapCountRequest,
  ambassadorWixDynamicPageRouterV1PageTypes.GetRouterSitemapCountRequest,
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetRouterSitemapCountResponse,
  ambassadorWixDynamicPageRouterV1PageTypes.GetRouterSitemapCountResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDynamicPageRouterV1Page.getRouterSitemapCount(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/sitemapCount',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRouterSitemap(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetRouterSitemapRequest,
  ambassadorWixDynamicPageRouterV1PageTypes.GetRouterSitemapRequest,
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetRouterSitemapResponse,
  ambassadorWixDynamicPageRouterV1PageTypes.GetRouterSitemapResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDynamicPageRouterV1Page.getRouterSitemap(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/sitemap',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRouterPages(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetRouterPagesRequest,
  ambassadorWixDynamicPageRouterV1PageTypes.GetRouterPagesRequest,
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetRouterPagesResponse,
  ambassadorWixDynamicPageRouterV1PageTypes.GetRouterPagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDynamicPageRouterV1Page.getRouterPages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pages',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRouterPagesCached(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetRouterPagesCachedRequest,
  ambassadorWixDynamicPageRouterV1PageTypes.GetRouterPagesCachedRequest,
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetRouterPagesResponse,
  ambassadorWixDynamicPageRouterV1PageTypes.GetRouterPagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDynamicPageRouterV1Page.getRouterPagesCached(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/pages',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDraftPreviewToken(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetDraftPreviewTokenRequest,
  ambassadorWixDynamicPageRouterV1PageTypes.GetDraftPreviewTokenRequest,
  ambassadorWixDynamicPageRouterV1PageUniversalTypes.GetDraftPreviewTokenResponse,
  ambassadorWixDynamicPageRouterV1PageTypes.GetDraftPreviewTokenResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDynamicPageRouterV1Page.getDraftPreviewToken(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-preview-token',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Page as PageOriginal,
  GetRouterSitemapCountRequest as GetRouterSitemapCountRequestOriginal,
  Config as ConfigOriginal,
  Pattern as PatternOriginal,
  PatternConfig as PatternConfigOriginal,
  PageRule as PageRuleOriginal,
  PageRole as PageRoleOriginal,
  GetRouterSitemapCountResponse as GetRouterSitemapCountResponseOriginal,
  RouterCountItem as RouterCountItemOriginal,
  GetRouterSitemapRequest as GetRouterSitemapRequestOriginal,
  GetRouterSitemapResponse as GetRouterSitemapResponseOriginal,
  RouterRouteItem as RouterRouteItemOriginal,
  GetRouterPagesRequest as GetRouterPagesRequestOriginal,
  RequestInfo as RequestInfoOriginal,
  GetRouterPagesResponse as GetRouterPagesResponseOriginal,
  RouterPagesResult as RouterPagesResultOriginal,
  RouterPageHead as RouterPageHeadOriginal,
  GetRouterPagesCachedRequest as GetRouterPagesCachedRequestOriginal,
  GetRouterPagesCachedUrlParams as GetRouterPagesCachedUrlParamsOriginal,
  GetDraftPreviewTokenRequest as GetDraftPreviewTokenRequestOriginal,
  GetDraftPreviewTokenResponse as GetDraftPreviewTokenResponseOriginal,
} from './dynamic-page-router-v1-page-pages.types.js';
